import { defineMessages } from 'react-intl';

export default defineMessages({
    applyingChangesMessage: {
        id: 'rewrite.eh.views.payment-details.Applying changes...',
        defaultMessage: 'Applying changes...'
    },
    completingYourPurchaseMessage: {
        id: 'rewrite.eh.views.payment-details.Completing your purchase...',
        defaultMessage: 'Completing your purchase...'
    },
    removeTPITitle: {
        id: 'rewrite.eh.views.payment-details.tpi.Remove Loss?',
        defaultMessage: 'Remove TPI?'
    },
    removeTPIDescription: {
        id: 'rewrite.eh.views.payment-details.tpi.message',
        defaultMessage: 'Are you sure you want to remove this TPI?'
    },
    consentToRateAcknowledgementMessage: {
        id: 'rewrite.common.views.payment-details.In accordance with G.S. 58-36-30(B1), your policy is currently being rated under North Carolina Consent to Rate regulations. The premium using North Carolina Bureau\'s rates for Homeowners insurance coverage applied for is $ {NCRBPremium}. Our premium for this coverage is $ {CTRPremium}.',
        defaultMessage: `In accordance with G.S. 58-36-30(B1), your policy is currently being rated under North Carolina Consent to Rate regulations. The premium using North Carolina Bureau\'s rates for Homeowners insurance coverage applied for is \${NCRBPremium}. Our premium for this coverage is \${CTRPremium}.`
    },
    confirmOk: {
        id: 'rewrite.eh.views.payment-details.tpi.Yes',
        defaultMessage: 'Yes'
    },
    cancel: {
        id: 'rewrite.eh.views.payment-details.tpi.No',
        defaultMessage: 'No'
    },
    signingAgent: {
        id: 'rewrite.eh.views.payment-details.Signing Agent',
        defaultMessage: 'Signing Agent'
    },
    signatureType: {
        id: 'rewrite.eh.views.payment-details.Signature Type',
        defaultMessage: 'Signature Type'
    },
    chooseSignature: {
        id: 'rewrite.eh.views.payment-details.Choose-Signature',
        defaultMessage: '--Choose a Signature Type--'
    },
    locationCode: {
        id: 'rewrite.eh.views.payment-details.Location Code',
        defaultMessage: 'Location Code'
    },
    locationCodeLabel: {
        id: 'rewrite.eh.views.payment-details.Location Code',
        defaultMessage: 'Location Code'
    },
    SigningAgent: {
        id: 'rewrite.eh.views.payment-details.Signing Agent',
        defaultMessage: 'Signing Agent'
    },
    paymentBuyNow: {
        id: 'rewrite.e1p.eh.views.payment-details.Buy Now',
        defaultMessage: 'Buy Now'
    },
    issueLabel: {
        id: 'rewrite.e1p.eh.views.payment-details.issueLabel',
        defaultMessage: 'Issue'
    },
    policyTerm: {
        id: 'rewrite.eh.views.payment-details.Policy Term',
        defaultMessage: 'Policy Term'
    },
    twelvemonths: {
        id: 'rewrite.eh.views.payment-details.12 Months',
        defaultMessage: '12 Months'
    },
    insuredContactTitle: {
        id: 'rewrite.eh.views.payment-details.insuredContactTitle',
        defaultMessage: 'Insured Contact'
    },
    homePhone: {
        id: 'rewrite.eh.views.payment-details.Home Phone',
        defaultMessage: 'Home Phone'
    },
    invalidPhone: {
        id: 'rewrite.eh.views.payment-details.Value entered must be a valid phone number',
        defaultMessage: 'Value entered must be a valid phone number'
    },
    homeTooltip: {
        id: 'rewrite.eh.views.payment-details.Home Phone.tooltip',
        defaultMessage: 'Home or Mobile Phone Required for Interior Inspection'
    },
    mobilePhone: {
        id: 'rewrite.eh.views.payment-details.Mobile Phone',
        defaultMessage: 'Mobile Phone'
    },
    invalidMobilePhone: {
        id: 'rewrite.eh.views.payment-details.Mobile.Value entered must be a valid phone number',
        defaultMessage: 'Value entered must be a valid phone number'
    },
    mobileTooltip: {
        id: 'rewrite.eh.views.payment-details.Mobile Phone.tooltip',
        defaultMessage: 'Home or Mobile Phone Required for Interior Inspection'
    },
    email: {
        id: 'rewrite.eh.views.payment-details.Email',
        defaultMessage: 'Email'
    },
    signature: {
        id: 'rewrite.eh.views.payment-details.signature',
        defaultMessage: 'Signature'
    },
    additionalInformation: {
        id: 'rewrite.eh.views.payment-details.Additional Information',
        defaultMessage: 'Additional Information'
    },
    unableToBindTitle: {
        id: 'rewrite.e1p.eh.views.payment-details.Unable to bind',
        defaultMessage: 'Unable to bind'
    }
});
